import officeProgramsReducer from "./reducers";
export { default as officeProgramsTypes } from "./types";
export { default as officeProgramsOperations } from "./operations";
export default officeProgramsReducer;
